export default "__VITE_ASSET__6b3524bf__"